import React from 'react';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import styled from 'styled-components';

const OPTION_HEIGHT = 35;

const VirtualizedMenuList = (props: any) => {
  const { options, children, maxHeight, getValue, selectProps } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * OPTION_HEIGHT;

  if (!children.length) {
    return (
      <NoOptionsMessage>
        {selectProps?.noOptionsMessage ? selectProps.noOptionsMessage({ inputValue: selectProps.inputValue }) : 'No options'}
      </NoOptionsMessage>
    );
  }

  const height = Math.min(maxHeight, children.length * OPTION_HEIGHT);

  return (
    <div style={{ height }}>
      <AutoSizer>
        {({ height: autoHeight, width }) => (
          <List
            height={autoHeight}
            width={width}
            itemCount={children.length}
            itemSize={OPTION_HEIGHT}
            initialScrollOffset={initialOffset}
          >
            {({ index, style }) => (
              <div
                style={{
                  ...style,
                  display: 'flex',
                  alignItems: 'center',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  padding: '0 10px',
                }}
                title={children[index]?.props?.label}
              >
                {children[index]}
              </div>
            )}
          </List>
        )}
      </AutoSizer>
    </div>
  );
};

const NoOptionsMessage = styled.div`
  height: ${OPTION_HEIGHT}px;
  min-height: ${OPTION_HEIGHT}px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  margin: 4px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: hsl(0, 0%, 60%);
`;

export default VirtualizedMenuList;
